// extracted by mini-css-extract-plugin
module.exports = {"input":"CommentInput_input__2LcVG","inputContent":"CommentInput_inputContent__2fyXc","button":"CommentInput_button__8o-SC","icon":"CommentInput_icon__3oXdC"};